/**
 * For updates to this see `alert.list_categories`.
 */
export enum AlertClassName {
  // Applications
  AppUpdate = 'AppUpdate',
  CatalogNotHealthy = 'CatalogNotHealthy',
  ApplicationsConfigurationFailed = 'ApplicationsConfigurationFailed',
  ApplicationsStartFailed = 'ApplicationsStartFailed',
  CatalogSyncFailed = 'CatalogSyncFailed',

  // Audit
  AuditBackendSetup = 'AuditBackendSetup',
  AuditDatabaseCorrupted = 'AuditDatabaseCorrupted',
  TrueNasVerifyServiceChangeDetection = 'TrueNASVerifyServiceChangeDetection',
  AuditServiceHealth = 'AuditServiceHealth',

  // Certificates
  CertificateExpired = 'CertificateExpired',
  CertificateIsExpiring = 'CertificateIsExpiring',
  CertificateIsExpiringSoon = 'CertificateIsExpiringSoon',
  CertificateParsingFailed = 'CertificateParsingFailed',
  WebUiCertificateSetupFailed = 'WebUiCertificateSetupFailed',

  // Directory Service
  DirectoryServiceBind = 'DirectoryServiceBind',
  DirectoryServiceDnsUpdate = 'DirectoryServiceDnsUpdate',

  // HA
  NoCriticalFailoverInterfaceFound = 'NoCriticalFailoverInterfaceFound',
  FailoverSyncFailed = 'FailoverSyncFailed',
  VrrpStatesDoNotAgree = 'VRRPStatesDoNotAgree',
  DisksAreNotPresentOnActiveNode = 'DisksAreNotPresentOnActiveNode',
  DisksAreNotPresentOnStandbyNode = 'DisksAreNotPresentOnStandbyNode',
  FailoverStatusCheckFailed = 'FailoverStatusCheckFailed',
  FailoverFailed = 'FailoverFailed',
  FailoverInterfaceNotFound = 'FailoverInterfaceNotFound',
  NetworkCardsMismatchOnActiveNode = 'NetworkCardsMismatchOnActiveNode',
  NetworkCardsMismatchOnStandbyNode = 'NetworkCardsMismatchOnStandbyNode',
  FailoverRemoteSystemInaccessible = 'FailoverRemoteSystemInaccessible',
  FailoverKeysSyncFailed = 'FailoverKeysSyncFailed',
  FailoverKmipKeysSyncFailed = 'FailoverKMIPKeysSyncFailed',
  TrueNasVersionsMismatch = 'TrueNASVersionsMismatch',

  // Hardware
  UsbStorage = 'USBStorage',
  DifFormatted = 'DifFormatted',
  EnclosureHealthy = 'EnclosureHealthy',
  EnclosureUnhealthy = 'EnclosureUnhealthy',
  JbofRedfishComm = 'JBOFRedfishComm',
  IpmiSel = 'IPMISEL',
  IpmiSelSpaceLeft = 'IPMISELSpaceLeft',
  NvdimmInvalidFirmwareVersion = 'NVDIMMInvalidFirmwareVersion',
  JbofElementCritical = 'JBOFElementCritical',
  JbofElementWarning = 'JBOFElementWarning',
  JbofInvalidData = 'JBOFInvalidData',
  JbofTearDownFailure = 'JBOFTearDownFailure',
  MemorySizeMismatch = 'MemorySizeMismatch',
  NvdimmEsLifetimeCritical = 'NVDIMMESLifetimeCritical',
  NvdimmEsLifetimeWarning = 'NVDIMMESLifetimeWarning',
  NvdimmRecommendedFirmwareVersion = 'NVDIMMRecommendedFirmwareVersion',
  NvdimmMemoryModLifetimeCritical = 'NVDIMMMemoryModLifetimeCritical',
  NvdimmMemoryModLifetimeWarning = 'NVDIMMMemoryModLifetimeWarning',
  OldBiosVersion = 'OldBiosVersion',
  PowerSupply = 'PowerSupply',
  SmartEraseCycleCount = 'SMARTEraseCycleCount',
  SmartFailedSelfTest = 'SMARTFailedSelfTest',
  SmartSpareBlockCount = 'SMARTSpareBlockCount',
  SmartUncorrectedErrors = 'SMARTUncorrectedErrors',
  DiskTemperatureTooHot = 'DiskTemperatureTooHot',
  SataDomWearCritical = 'SATADOMWearCritical',
  SataDomWearWarning = 'SATADOMWearWarning',
  Sensor = 'Sensor',
  Nvdimm = 'NVDIMM',
  MemoryErrors = 'MemoryErrors',

  // KMIP
  KmipConnectionFailed = 'KMIPConnectionFailed',
  KmipSedGlobalPasswordSyncFailure = 'KMIPSEDGlobalPasswordSyncFailure',
  KmipSedDisksSyncFailure = 'KMIPSEDDisksSyncFailure',
  KmipZfsDatasetsSyncFailure = 'KMIPZFSDatasetsSyncFailure',

  // Network
  BondMissingPorts = 'BONDMissingPorts',
  BondInactivePorts = 'BONDInactivePorts',
  BondNoActivePorts = 'BONDNoActivePorts',

  // Reporting
  SyslogNg = 'SyslogNg',

  // Sharing
  DeprecatedService = 'DeprecatedService',
  IscsiPortalIp = 'ISCSIPortalIP',
  NfsExportMappingInvalidNames = 'NFSexportMappingInvalidNames',
  NfsHostnameLookupFail = 'NFSHostnameLookupFail',
  NfsBlockedByExportsDir = 'NFSblockedByExportsDir',
  Ntlmv1Authentication = 'NTLMv1Authentication',
  SmbPath = 'SMBPath',
  SmbLegacyProtocol = 'SMBLegacyProtocol',
  ShareLocked = 'ShareLocked',
  IscsiDiscoveryAuthMixed = 'ISCSIDiscoveryAuthMixed',
  IscsiDiscoveryAuthMultipleMutualChap = 'ISCSIDiscoveryAuthMultipleMutualCHAP',
  IscsiDiscoveryAuthMultipleChap = 'ISCSIDiscoveryAuthMultipleCHAP',
  IscsiAuthSecretInvalidChar = 'ISCSIAuthSecretInvalidChar',
  IscsiAuthSecretWhitespace = 'ISCSIAuthSecretWhitespace',
  NfsHostListExcessive = 'NFSHostListExcessive',
  NfsNetworkListExcessive = 'NFSNetworkListExcessive',
  SmbAuditShareDisabled = 'SMBAuditShareDisabled',
  SmbUserMissingHash = 'SMBUserMissingHash',
  SmbVeeamFastClone = 'SMBVeeamFastClone',
  S3BucketDatasetMissing = 'S3BucketDatasetMissing',
  FcHardwareAdded = 'FCHardwareAdded',
  FcHardwareReplaced = 'FCHardwareReplaced',

  // Storage
  QuotaCritical = 'QuotaCritical',
  PoolUpgraded = 'PoolUpgraded',
  ZpoolCapacityNotice = 'ZpoolCapacityNotice',
  ZpoolCapacityWarning = 'ZpoolCapacityWarning',
  ZpoolCapacityCritical = 'ZpoolCapacityCritical',
  VolumeStatus = 'VolumeStatus',
  QuotaWarning = 'QuotaWarning',
  ScrubPaused = 'ScrubPaused',
  TierSpecialVdevWarning = 'TierSpecialVdevWarning',
  TierSpecialVdevCritical = 'TierSpecialVdevCritical',
  SnapshotTotalCount = 'SnapshotTotalCount',
  SnapshotCount = 'SnapshotCount',

  // System
  ApiKeyRevoked = 'ApiKeyRevoked',
  ApiFailedLogin = 'APIFailedLogin',
  AdminUserIsOverridden = 'AdminUserIsOverridden',
  AdminSession = 'AdminSession',
  BootPoolStatus = 'BootPoolStatus',
  FailoverReboot = 'FailoverReboot',
  FencedReboot = 'FencedReboot',
  NtpHealthCheck = 'NTPHealthCheck',
  TruecommandConnectionPending = 'TruecommandConnectionPending',
  ProactiveSupport = 'ProactiveSupport',
  SshLoginFailures = 'SSHLoginFailures',
  KdumpNotReady = 'KdumpNotReady',
  SystemTesting = 'SystemTesting',
  CurrentlyRunningVersionDoesNotMatchProfile = 'CurrentlyRunningVersionDoesNotMatchProfile',
  GmailConfigurationDiscarded = 'GMailConfigurationDiscarded',
  InvalidGpuPciIds = 'InvalidGpuPciIds',
  TimezoneNotAvailable = 'TimezoneNotAvailable',
  AllAdminAccountsExpired = 'AllAdminAccountsExpired',
  FipsMisconfiguration = 'FIPSMisconfiguration',
  LocalAccountExpired = 'LocalAccountExpired',
  LocalAccountExpiring = 'LocalAccountExpiring',
  TncDisabledAutoUnconfigured = 'TNCDisabledAutoUnconfigured',
  TncHeartbeatConnectionFailure = 'TNCHeartbeatConnectionFailure',
  TruecommandConnectionDisabled = 'TruecommandConnectionDisabled',
  TruecommandContainerHealth = 'TruecommandContainerHealth',
  TruecommandConnectionHealth = 'TruecommandConnectionHealth',
  LicenseHasExpired = 'LicenseHasExpired',
  LicenseIsExpiring = 'LicenseIsExpiring',
  License = 'License',
  EncryptedDataset = 'EncryptedDataset',
  HasUpdate = 'HasUpdate',

  // Tasks
  CloudBackupTaskFailed = 'CloudBackupTaskFailed',
  CloudSyncTaskFailed = 'CloudSyncTaskFailed',
  VmwareSnapshotTaskFailed = 'VMWareSnapshotCreateFailed',
  ReplicationFailed = 'ReplicationFailed',
  ReplicationSuccess = 'ReplicationSuccess',
  RsyncFailed = 'RsyncFailed',
  RsyncSuccess = 'RsyncSuccess',
  ScrubNotStarted = 'ScrubNotStarted',
  ScrubStarted = 'ScrubStarted',
  SnapshotFailed = 'SnapshotFailed',
  TaskLocked = 'TaskLocked',
  CloudProviderRemoved = 'CloudProviderRemoved',
  TierJobError = 'TierJobError',
  TierJobComplete = 'TierJobComplete',
  VmwareLoginFailed = 'VMWareLoginFailed',
  VmwareSnapshotDeleteFailed = 'VMWareSnapshotDeleteFailed',

  // UPS
  UpsBatteryLow = 'UPSBatteryLow',
  UpsReplaceBattery = 'UPSReplbatt',
  UpsCommunicationOk = 'UPSCommok',
  UpsCommunicationBad = 'UPSCommbad',
  UpsOnBattery = 'UPSOnBattery',
  UpsOnline = 'UPSOnline',
}
